import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import BasicAlert from 'Components/ComponentLibrary/Atoms/Alerts/Basic';

const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    fontSize: theme.typography.h6.fontSize,
  },
  rootHidden: {
    display: 'none',
  },
});

const Message = ({
  className,
  classes,
  message,
}) => {
  return (
    <BasicAlert
      className={classNames(classes.root, className, {
        [classes.rootHidden]: !message || message === '',
      })}
      severity={'info'}
      title={message}
    />
  );
};

Message.defaultProps = {
  className: '',
  message: null,
};

Message.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
};

export default withStyles(styles)(Message);
